import { render } from "./PriceUpdateAlert.vue?vue&type=template&id=765e69b9&scoped=true"
import script from "./PriceUpdateAlert.vue?vue&type=script&lang=js"
export * from "./PriceUpdateAlert.vue?vue&type=script&lang=js"

import "./PriceUpdateAlert.vue?vue&type=style&index=0&id=765e69b9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765e69b9"]])

export default __exports__